export const getHost = () => {
  if (window.location.hostname === "localhost") {
    return "/api";
  } else {
    return "https://vibelist.herokuapp.com";
  }
};

